import { computed, isRef, type ComputedRef, type Ref } from 'vue'

export type ThemeType =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'accent'
  | 'positive'
  | 'negative'
  | 'info'
  | 'warning'
  | 'purple'
  | 'orange'
  | 'teal'
  | 'muted'
  | 'bordered'
  | 'transparent'

/**
 * Theme management composable
 * @public
 * @useWhen need theme support; want to apply theme classes to components
 */
export function useTheme(theme: ComputedRef<ThemeType> | Ref<ThemeType> | ThemeType = 'default') {
  const themeClass = computed(() => {
    const themeMap: Record<ThemeType, string> = {
      default: 'theme-default',
      primary: 'theme-primary',
      secondary: 'theme-secondary',
      accent: 'theme-accent',
      positive: 'theme-positive',
      negative: 'theme-negative',
      info: 'theme-info',
      warning: 'theme-warning',
      purple: 'theme-purple',
      orange: 'theme-orange',
      teal: 'theme-teal',
      muted: 'theme-muted',
      bordered: 'theme-bordered',
      transparent: 'theme-transparent',
    }

    // Get the current theme value, handling both ref and direct value cases
    const currentTheme: ThemeType = isRef(theme) ? theme.value : theme
    return themeMap[currentTheme]
  })

  return {
    themeClass,
  }
}
